export const Wave = ({ className = "" }) => (
    <svg viewBox="0 0 120 14" fill="none" className={className} aria-hidden="true" focusable="false">
        <path
            d="M2 9 C 12 3, 22 3, 32 9 S 52 15, 62 9 S 82 3, 92 9 S 112 15, 118 9"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
        />
    </svg>
);